import './book-verification-call.modal.scss';

export default function BookVerificationCallModal($scope, close) {
  'ngInject';

  $scope.bookCall = {
    message: ''
  };

  $scope.ok = (form) => {
    if (form.$valid) {
      close($scope.bookCall.message);
    }
  };

  $scope.close = () => {
    close();
  };

}